metaTagService.$inject = [
  '$rootScope',
  '$window',
  '$location'
];

const serviceEventNamespace = 'metatag-service-event';

const defaults = {
  title: 'Tablelist',
  description: 'Tablelist provides instant access to VIP bottle service, private tables and exclusive events in a growing number of cities across the country.',

  // Facebook
  facebookTitle: 'Tablelist - A better night out',
  facebookDescription: 'Life is a celebration, and finding the party has never been easier.',
  facebookImage: 'https://assets.tablelist.com/www-2/images/tablelist-header-image-better-night-out.jpg',

  // Twitter
  twitterTitle: 'Tablelist - A better night out',
  twitterDescription: 'Life is a celebration, and finding the party has never been easier.',
  twitterImage: 'https://assets.tablelist.com/www-2/images/tablelist-header-image-better-night-out.jpg',

  // Deep links
  deeplink: '/',

  // SEO
  canonicalUrl: null,
  statusCode: 200
};

export default function metaTagService($rootScope, $window, $location) {
  class MetaTagService {
    constructor() {
      this._meta = defaults;
    }

    get meta() {
      return this._meta;
    }

    publish(eventName, msg) { //eslint-disable-line
      if (!eventName) return;

      $rootScope.$emit(serviceEventNamespace, {
        event: eventName,
        msg: msg
      });
    }

    subscribe(eventName, scope, callback) { //eslint-disable-line
      if (!scope || !eventName || !callback) return;

      const handler = $rootScope.$on(serviceEventNamespace, function(event, msg) {
        if (msg && msg.event === eventName) {
          return callback(msg.msg);
        }

        return null;
      });

      scope.$on('$destroy', handler);
    }

    /**
     * Set the meta tags for the given page.
     * Un-provided keys will fallback to defaults.
     *
     * @method set
     * @param {Object} input
     * @param {Object} [input.title]
     * @param {Object} [input.description]
     * @param {Object} [input.canonicalPath]
     * @param {Object} [input.statusCode]
     * @param {Object} [input.facebookTitle]
     * @param {Object} [input.facebookDescription]
     * @param {Object} [input.facebookImage]
     * @param {Object} [input.twitterTitle]
     * @param {Object} [input.twitterDescription]
     * @param {Object} [input.twitterImage]
     * @param {Object} [input.deeplink]
     * @return {Object}
     */
    set(input) {
      input = input || {};

      const canonicalUrl = $window.location.origin + (input.canonicalPath || $location.path());

      this._meta = {
        title: `Tablelist | ${input.title || defaults.title}`,
        description: input.description || defaults.description,

        // Facebook
        facebookTitle: input.facebookTitle || input.title || defaults.facebookTitle,
        facebookDescription: input.facebookDescription || input.description || defaults.facebookDescription,
        facebookImage: input.facebookImage || defaults.facebookImage,

        // Twitter
        twitterTitle: input.twitterTitle || input.title || defaults.facebookTitle,
        twitterDescription: input.twitterDescription || input.description || defaults.facebookDescription,
        twitterImage: input.twitterImage || defaults.facebookImage,

        //Deep link
        deeplink: input.deeplink || defaults.deeplink,

        // Crawlers
        canonicalUrl: canonicalUrl,
        statusCode: input.statusCode || defaults.statusCode
      };

      this.publish('tagsChanged');

      return this._meta;
    }

    /**
     * Set a specfic meta key
     *
     * @method setKey
     * @param {String} key
     * @param {String} value
     * @return {String} key
     */
    setKey(key, value) {
      if (!key || !value) return null;

      this._meta[key] = value;

      this.publish('tagsChanged');

      return key;
    }

    /**
     * @method getKey
     * @param {String} key
     * @return {String} key
     */
    getKey(key) {
      if (!key) return null;

      return this._meta[key];
    }
  }

  return new MetaTagService();
}



// WEBPACK FOOTER //
// ./src/services/metaTagService.js